import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 11\" id=\"minus\">\r\n<style type=\"text/css\">\r\n\t#minus .st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n</style>\r\n<g>\r\n\t<path class=\"st0\" d=\"M0,4.1h12V7H0V4.1z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol